module.exports = __webpack_public_path__ + "2436fa3d807f5f6892039dfffbdce9ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/video.png
// module id = 1534
// module chunks = 0